import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import cover from 'assets/viniloviRBar.png';
import Settings from '../../../../../assets/settings.svg'
import { useLocation, useParams } from 'react-router';
import { useSmartLink } from '../../../../../hooks/useSmartLink'
import { useRelease } from 'components/NewRelease/hooks/useRelease';
import Shiotify from '../../../../../assets/shiotify.svg';
import Youthube from '../../../../../assets/YouTubeIcon.svg';
import Instagram from '../../../../../assets/instagram.svg';
import BwInstagram from '../../../../../assets/bwInstagram.svg'
import SmartYCover from '../../../../../assets/smartYCover.png'

interface RigthBarProps {
    values: any;
    setValues: (values: any) => void;
}

export const RigthBar: React.FC<RigthBarProps> = ({ values, setValues }) => {
    const { release, fetching, fetchRelease } = useRelease();


    useEffect(() => {
        fetchRelease()
    }, [])

    const { data: allData } = useSmartLink();

    const [artist, setArtist] = useState('');
    const [track, setTrack] = useState('');
    const params = useParams()
    const id = params.id
    const location = useLocation();
    const lastSegment = location.pathname.split('/').pop();
    const data = lastSegment === 'edit' && allData?.filter((value: any) => value.id == id);

    useEffect(() => {
        const decoded = decodeURIComponent(lastSegment === 'edit' ? data?.[0]?.release?.title : release?.title);
        const [artist, track] = decoded.split('—').map((part) => part.trim());
        setArtist(artist);
        setTrack(track);
    }, [data]);

    function extractPlatformNames(links: any[]) {
        if (!Array.isArray(links)) return [];

        return links
            .map(item => {
                try {
                    const domain = new URL(item.url).hostname;
                    const parts = domain.split('.');
                    return parts.find(p => p !== 'www' && p !== 'com') || null;
                } catch {
                    return null;
                }
            })
            .filter(Boolean);
    }

    return (
        !fetching && <Content>
            <ContentBox>
                <Box>
                    <Cover src={cover}>
                    </Cover>
                    <DataBox>
                        <TextBox>
                            <TitleBox>
                                <Title>
                                    <div>{artist || ''}</div>
                                    <span>{track || ''}</span>
                                </Title>
                                <Settings />
                            </TitleBox>
                            {values.description && <Data>
                                <span>{values.description}</span>
                            </Data>}
                        </TextBox>
                        <Platform>
                            {extractPlatformNames(data?.[0]?.platform_links).map((val, id) => (
                                <PlatformRow key={id}>
                                    <div style={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                                        {val === 'youtube' && <Youthube />}
                                        {val === 'shiotify' && <Shiotify />}
                                        {val === 'instagram' && <Instagram />}
                                        <span>{(val ?? '').charAt(0).toUpperCase() + (val ?? '').slice(1)}</span>
                                    </div>
                                    <Play>Play</Play>
                                </PlatformRow>
                            ))}
                        </Platform>
                        <SmartYCoverBox>
                            <img src={SmartYCover}/>
                            </SmartYCoverBox>
                    </DataBox>
                    <Instabox>
                        <BwInstagram />
                    </Instabox>

                </Box>
            </ContentBox>
        </Content>
    );
};

const Content = styled.div`
  width: 40%;
  height: 1015px;
  display: flex;
  background-image: url(${cover});
  background-size: cover;       
  background-position: center;  
  background-repeat: no-repeat; 
  border-radius: 25px;
  

`;

const ContentBox = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(38, 38, 38, 0.8);
    border-radius: 25px;
    padding: 28px 22px 0 23px;

`
const Box = styled.div`
    width: 100%;
    min-height: 607px;
    border-radius: 25px;
    background: rgba(61, 61, 61, 1);
    position: relative;
`
const Cover = styled.img`
    width:380px;
    height: 346px;
    border-radius: 0;
`

const DataBox = styled.div`
    padding: 0 15px 0 16px;
    min-height: 202px;
    background: rgba(38, 38, 38, 1);
    z-index: 1;

`

const TextBox = styled.div`
    width: calc(100% - 29px);
    min-height: 91px;
    background: rgba(61, 61, 61, 1);
    border-radius: 20px;
    padding: 24px 18px 20px 17px;
    position: absolute;
    top: 295px;

`
const TitleBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`
const Title = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: #FFFFFF;

    div{
        font-family: Outfit;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
    }

    span{
        font-family: SF Pro Display;
        font-weight: 300;
        font-style: Light;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
    }
`
const Data = styled.div`
    width: 100%;
    border-top: 1px solid #FFFFFF;
    display:flex;
    flex-direction: column;
    padding-top: 20px;   
    font-family: SF Pro Display;
    font-weight: 300;
    font-style: Light;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color: #FFFFFF;
    margin-top: 20px;
`
const Platform = styled.div`
    padding-top: 120px;
    display:flex;
    flex-direction: column;
    gap:15px;
`
const PlatformRow = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-family: SF Pro Display;
    font-weight: 300;
    font-style: Light;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 14px;
    letter-spacing: 0%;
    color:rgba(255, 255, 255, 1);
`
const Play = styled.div`
   display:flex;
    justify-content: center;
    align-items: center;
    width: 66px;
    height: 25px;
    border-radius: 6px;
    background:rgba(255, 255, 255, 1);
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    color:rgba(103, 119, 255, 1);
`

const Instabox = styled.div`
    width:100%;
    height:59px;
    display:flex;
    justify-content: center;
    align-items: center;
`

const SmartYCoverBox = styled.div`
    padding:20px 0;
`